module.exports = __webpack_public_path__ + "static/media/icon04.b4deedcd.png";